import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  timelineItemClasses,
} from '@mui/lab';
import { Box, Typography, Divider, Link } from '@mui/material';

import stackAdaptLogo from '../assets/experience/stackadapt.png';
import imagineLogo from '../assets/experience/imagine-communications.png';
import searchspringLogo from '../assets/experience/searchspring.svg';
import topHatLogo from '../assets/experience/top-hat.png';
import titanLogo from '../assets/experience/titan.png';
import SplashReveal from '../components/SplashReveal';

const Experience = () => {
  const experience = [
    {
      company: 'StackAdapt',
      description:
        'Built an internal Rails API to target users in programmatic ad campaigns, saving ~4 weeks of dev time. Integrated Salesforce for granular audience segmentation based on custom properties.',
      date: 'Jan 2025 – Apr 2025',
      logo: stackAdaptLogo,
      url: 'https://www.stackadapt.com/',
    },
    {
      company: 'Titan',
      description:
        'Led development of an external asset transfer system driving $4M/month in flow. Built SEC-compliant performance charts and streamlined advisor scheduling, increasing deposits by $1M/month.',
      date: 'Jan 2024 – Aug 2024',
      logo: titanLogo,
      url: 'https://www.titan.com/',
    },
    {
      company: 'Top Hat',
      description:
        'Launched key features for a new Questions platform used by 1M+ users. Authored an RFC proposing implementation guidelines to unlock observability of user behaviours.',
      date: 'Jan 2023 – Apr 2023',
      logo: topHatLogo,
      url: 'https://tophat.com/',
    },
    {
      company: 'Searchspring',
      description:
        'Reduced development Docker image size by 15% and enabled multi-arch builds. Refactored monolithic PHP features into Golang microservices, improving response time by 20%.',
      date: 'May 2022 – Aug 2022',
      logo: searchspringLogo,
      url: 'https://searchspring.com/',
    },
    {
      company: 'Imagine Communications',
      description:
        'Cut API response time by 60% by implementing async flows with RabbitMQ. Built support for user-defined, backward-compatible tags for content automation.',
      date: 'Jan 2022 – Apr 2022',
      logo: imagineLogo,
      url: 'https://imaginecommunications.com/',
    },
  ];

  return (
    <Box component='section' sx={{ mx: { xs: 5, sm: 0 } }}>
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        co-op experience
      </Typography>

      <Timeline
        sx={{
          pl: 0,
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {experience.map(({ company, description, date, logo, url }, index) => (
          <TimelineItem key={company}>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  p: 0,
                  width: 40,
                  height: 40,
                  backgroundColor: 'black',
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Link href={url} target='_blank' rel='noopener'>
                  <SplashReveal src={logo} alt={`${company} logo`} size={30} />
                </Link>
              </TimelineDot>
              {index < experience.length - 1 && <TimelineConnector sx={{ bgcolor: 'black' }} />}
            </TimelineSeparator>

            <TimelineContent sx={{ pb: 2 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'space-between',
                  pb: { xs: 2, sm: 0 },
                }}
              >
                <Link href={url} target='_blank' rel='noopener'>
                  <Typography variant='h6' sx={{ fontFamily: 'serif', fontWeight: 500 }}>
                    {company}
                  </Typography>
                </Link>
                <Typography variant='body2'>{date}</Typography>
              </Box>

              {description && <Typography variant='body2'>{description}</Typography>}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
};

export default Experience;
